<template>
  <div class="main-table-wrap">
    <el-table show-summary :summary-method="getSummaries" :data="tableData" border style="width: 100%" :header-cell-style="tableHeaderColor">
      <el-table-column v-for="(items,index) in columns" :key="index" :prop="items.prop" :label="items.label" :align="items.align?items.align:'center'">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { isNull, isUndefined } from "util";
export default {
  name: "cdcbTable",
  props: {
    selectedMeasure: {
      type: Object,
      default: {
        measureId: "",
        measureName: ""
      }
    },
    timeElem: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      tableData: [],//表格数据
      columns: [
        { prop: "name", label: "名称", align: "left" },
        { prop: "provalue", label: "上期读数", align: "right" },
        { prop: "protime", label: "上期读数时间", align: "right" },
        { prop: "nowvalue", label: "本期读数", align: "right" },
        { prop: "nowtime", label: "本期读数时间", align: "right" },
        { prop: "allvalue", label: "用电量(kWh)", align: "right" }
      ],
      pointCode: "100229",
      pointNumber: "0"
    }
  },
  methods: {
    async getData () {
      let tablearr = [];
      let measureIds = [{
        measureId: this.selectedMeasure.measureId,
        pointCode: "229",
        pointNumber: this.pointNumber
      }]
      let measureQuantityIds = [{
        measureId: this.selectedMeasure.measureId,
        pointCode: "100229",
        pointNumber: this.pointNumber
      }];
      let axiosArr = [
        this.$api.measuringRaw.getMeasuringRawValue2(measureIds, this.timeElem.startTime, this.timeElem.endTime, "0", "1"), //环期
        this.$api.measuringRaw.getMeasuringRawValue2(measureIds, this.timeElem.startTime, this.timeElem.endTime, "1", "1"), //本期
        this.$api.quantity.getQuantity2(JSON.stringify(measureQuantityIds), this.timeElem.startTime, this.timeElem.endTime, null)
      ]
      let result = await Promise.all(axiosArr);
      let obj = { name: this.selectedMeasure.measureName, provalue: "-", protime: "-", nowvalue: "-", nowtime: "-", allvalue: "-", measureId: this.selectedMeasure.measureId }
      result[0].data.forEach((item, y) => {
        if (obj.measureId == item.measureId) {
          obj.protime = result[0].data[y].data.data.length == 0
            ? "-"
            : result[0].data[y].data.data[0].time;
          obj.provalue = result[0].data[y].data.data.length == 0
            ? "-"
            : result[0].data[y].data.data[0].value.toFixed(2)
          obj.nowtime = result[1].data[y].data.data.length == 0
            ? "-"
            : result[1].data[y].data.data[0].time;
          obj.nowvalue = result[1].data[y].data.data.length == 0
            ? "-"
            : result[1].data[y].data.data[0].value.toFixed(2)
          obj.allvalue = isNull(result[2].data[y].value) ? "-" : result[2].data[y].value.toFixed(2);
        }
      })
      let values = [obj.provalue, obj.nowvalue]
      tablearr.push(obj);
      if (tablearr.length == 0) {//[]
        tablearr.push({
          allvalue: "-",
          measureId: this.selectedMeasure.measureId,
          name: this.selectedMeasure.measureName,
          nowtime: "-",
          nowvalue: "-",
          pronowtimetime: "-",
          protime: "-",
          provalue: "-",
        })
      }
      this.tableData = Object.assign([], tablearr);
    },
    getSummaries (param) {
      console.log(param);
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          if (index === 5) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev
              }
            }, 0);
          } else {
            sums[index] = "-"
          }
        } else {
          sums[index] = '-';
        }
      });
      return sums;
    },
    tableHeaderColor ({ row, column, rowIndex, columnIndex }) { //改表头颜色
      if (rowIndex === 0) {
        return 'background-color: #F3F3F3;color: #666;';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main-table-wrap {
  background: #fff;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  box-sizing: border-box;
  overflow: hidden;
  padding: 10px;
  text-align: left;
  color: #333;
  ::v-deep .el-table--border {
    border-bottom: 1px solid #ebeef5;
  }
  ::v-deep .table-warp .el-table td {
    border-bottom: 1px solid #ebeef5;
  }
  div {
    height: 100% !important;
  }
}
</style>